<template>
  <section class="about-hero">
    <div class="container">
      <div class="about-header-content">
        <h1 class="animate-up">About Vipandeep Singh</h1>
        <p class="subtitle animate-up delay-1">
          Your Dedicated Partner in Tricity Real Estate
        </p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}
.about-hero {
  padding: 90px 0 80px;
  text-align: center;
  position: relative;

  background-color: #7a2929;

  background-image: url("data:image/svg+xml,%3Csvg width='60' height='12' viewBox='0 0 60 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 6c9.333 0 9.333 6 18.667 6S50.667 0 60 0v12H0V0c9.333 0 9.333 6 18.667 6S20.667 0 30 0v6z' fill='%23e0e0e0' fill-opacity='0.3' fill-rule='evenodd'/%3E%3C/svg%3E");
  border-bottom: 1px solid #eee;
}

.about-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(248, 248, 248, 0.8) 0%,
    rgba(248, 248, 248, 1) 100%
  );
  z-index: 1;
}

.about-header-content {
  position: relative;
  z-index: 2;
}

.about-header-content h1 {
  font-size: 3.5rem;
  color: #111;
  margin-bottom: 10px;
  font-weight: 800;
  line-height: 1.2;
}

.subtitle {
  font-size: 1.25rem;
  color: #b91c1c;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Animations */
.animate-up {
  animation: fadeInUp 0.8s ease forwards;
  opacity: 0;
}

.delay-1 {
  animation-delay: 0.2s;
}

@keyframes fadeInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
